import React from 'react';

export class Container extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    createStyles() {
        const p = this.props;
        return { width: p.width, height: p.height }
    }

    render() {
        const p = this.props;
        let styles = this.createStyles();
        return (
            <div
                className={ `marketkit-skeleton${p.className ? ' ' + p.className : ''}`}
                style={ styles }
            >
                { p.children }
            </div>
        )
    }
}

export default Container